import { customFieldBuilderTr } from './custom-field-builder-i18n';
import { translationCenterTr } from './translation-center-i18n';
import { backupCenterTr, backupRestoreTr } from './backup-center-i18n';

/** Translations for the administration area; wired up in lib/i18n/en.ts. */
export const adminTr = {
  nav: {
    label: 'Yönetim',
    system: 'Sistem ve telemetri',
    errorLogs: 'Hata merkezi',
    customFields: 'Özel alanlar',
    auditVault: 'GoBD denetim kasası',
    dataHub: 'İçe ve dışa aktarma',
    mailBackups: 'Posta gönderimi',
    backups: 'Yedekleme merkezi',
    whatsapp: 'WhatsApp',
    telephonyAi: 'Telefon ve Yapay Zeka',
  },
  errorLogs: {
    title: 'Hata merkezi',
    subtitle: 'Sistem hataları tam bağlamıyla birlikte merkezi olarak günlüğe kaydedildi.',
    loadError: 'Hata günlükleri yüklenemedi.',
    emptyTitle: 'Hiçbir hata günlüğe kaydedilmedi',
    emptyHint: 'Seçilen filtrelerle eşleşen giriş yok.',
    kpi: {
      unresolved: 'Açma hataları',
      last24h: 'Son 24 saat',
    },
    filters: {
      search: 'Ara',
      searchPlaceholder: 'İzleme Kimliği, mesaj veya uç nokta',
      httpStatus: 'HTTP durumu',
      from: 'Başlangıç',
      to: 'Bitiş',
      unresolvedOnly: 'Yalnızca çözümlenmemiş',
      reset: 'Filtreleri sıfırla',
    },
    columns: {
      timestamp: 'Zaman Damgası',
      status: 'Durum',
      trackingId: 'Takip Kimliği',
      user: 'Kullanıcı',
      endpoint: 'Uç nokta',
      message: 'Mesaj',
      state: 'İşleme',
    },
    state: {
      open: 'Aç',
      resolved: 'Çözüldü',
    },
    detail: {
      title: 'Hata ayrıntıları',
      ip: 'IP adresi',
      client: 'İstemci',
      message: 'Mesaj',
      context: 'İş bağlamı',
      payload: 'Yük iste',
      payloadHint: 'Şifreler, jetonlar ve banka bilgileri saklanmadan önce kaldırılır.',
      stackTrace: 'Yığın izleme',
      notes: 'Çözüm notu',
      resolved: 'Hata çözüldü olarak işaretlendi.',
      reopened: 'Hata yeniden açıldı.',
      resolvedBy: '{{date}} üzerinde {{name}} tarafından çözüldü.',
    },
    actions: {
      resolve: 'Çözüldü olarak işaretle',
      reopen: 'Yeniden aç',
      openDocument: 'Etkilenen belgeyi aç',
      export: 'Destek raporunu dışa aktar',
    },
  },
  status: {
    OK: 'Tamam',
    WARNING: 'Uyarı',
    CRITICAL: 'Kritik',
  },
  system: {
    title: 'Sistem ve telemetri',
    subtitle: 'Bir bakışta çalışma zamanı, veritabanı ve sunucu.',
    error: 'Telemetri yüklenemedi.',
    refresh: 'Yenile',
    application: 'Başvuru',
    database: 'Veritabanı',
    server: 'Sunucu',
    version: 'Sürüm',
    commit: 'Taahhüt',
    node: 'Node.js',
    environment: 'Ortam',
    uptime: 'Çalışma Süresi',
    heap: 'Yığın',
    dbSize: 'Veritabanı boyutu',
    connections: 'Bağlantılar',
    streamClients: 'Canlı istemciler',
    scheduler: 'Arka plan işleri',
    schedulerStopped: 'Çalışmıyor',
    auditEntries: 'Denetim girişleri',
    cores: 'CPU çekirdeği',
    loadAverage: 'Yük ortalaması',
    memory: 'Bellek',
    backupDisk: 'Yedek depolama alanı',
    unavailable: 'Kullanılamıyor',
    collectedAt: 'Toplama tarihi:',
    cpu: 'CPU yükü',
    eventLoop: 'Olay döngüsü {{value}} ms',
    cacheHit: 'Önbellek isabet oranı {{value}} %',
    gauges: 'Kullanım',
    gaugesHint: 'Değerler her 15 saniyede bir yenilenir.',
    features: 'Özellikler ve modüller',
    featuresHint: 'Etkin kullanılabilirlik, yapılandırma sorunları ve duraklatılan işler.',
    featuresActive: 'Etkin',
    featuresDisabled: 'Devre dışı',
    featuresMisconfigured: 'Yanlış yapılandırılmış',
    featuresBlocked: 'Bağımlılıklar engellendi',
    featuresPausedJobs: 'Duraklatılan işler',
    featuresLastChanges: 'Son özellik değişiklikleri',
    featuresNoChanges: 'Kaydedilmiş değişiklik yok.',
    featureActive: 'etkin',
    featureInactive: 'etkin değil',
    quickActions: 'Hızlı işlemler',
    quickActionsHint: 'Bakım görevleri ve önbellekler.',
    clearCache: 'Önbelleği temizle',
    cacheCleared: '{{count}} önbelleğe alınmış dosyalar kaldırıldı.',
    maintenanceMode: 'Bakım modu',
    maintenanceHint: 'İzin verilen adresler dışındaki herkes için uygulamayı engeller.',
    maintenanceMessage: 'Bildirim',
    allowedIps: 'İzin verilen IP adresleri',
    allowedIpsHint: 'Virgülle ayrılmış, 10.0.0.0/8 gibi CIDR aralıklarına izin verilir.',
    maintenanceSaved: 'Ayarlar kaydedildi.',
  },
  customFields: {
    ...customFieldBuilderTr,
    translationCenter: translationCenterTr,
    title: 'Özel alanlar',
    subtitle: 'Kod değişikliği olmadan veri alanı başına kendi alanları.',
    create: 'Yeni özel alan',
    created: 'Özel alan oluşturuldu.',
    updated: 'Özel alan kaydedildi.',
    archived: 'Özel alan arşivlendi.',
    empty: 'Henüz özel alan yok',
    emptyHint: 'Ek bilgi almak için bir alan oluşturun.',
    dialogTitle: 'Özel alan oluştur',
    editTitle: 'Özel alanı düzenle',
    edit: 'Düzenle',
    dialogDescription: 'Alan {{entity}} formlarında görünür.',
    label: 'Görünen ad',
    key: 'Anahtar',
    keyHint: 'Teknik ad; oluşturulduktan sonra sabitlenir.',
    description: 'Açıklama',
    group: 'Kategori',
    groupPlaceholder: 'Kategori seçin',
    type: 'Veri türü',
    pattern: 'Doğrulama normal ifadesi',
    patternHint: 'İsteğe bağlı format kontrolü, ör. ^[A-Z]{2}\\d{4}$.',
    options: 'Seçenekler',
    optionLabel: 'Seçenek etiketi',
    addOption: 'Ekle seçeneği',
    removeOption: 'Kaldır seçeneği',
    noOptions: 'Henüz seçenek yok',
    required: 'Gerekli',
    inPdf: "PDF'ye yazdır",
    searchable: 'Aranabilir',
    marketingSegmentationAllowed: 'Bülten segmentasyonu için onayla',
    marketingSegmentationHint:
      'Yalnızca incelemeden sonra ve hassas olmayan alanlar için etkinleştirin.',
    inList: 'Tablolarda göster',
    inherit: 'Takip belgelerine devret',
    inheritHint: 'Değer, teklif → sipariş → irsaliye → faturayı otomatik olarak takip eder.',
    inherited: 'Devralındı',
    inItemTable: 'Öğe tablosunda göster',
    inItemTableHint: "Öğe satırının altında ve PDF'de görünür.",
    copyFromProduct: 'Ürün değerini öğeye kopyala',
    copyFromProductHint: 'Ürün eklendiğinde ana veri değeri belge öğesine kopyalanır.',
    documentTypesTitle: 'Belge türleri için geçerlidir',
    documentTypesHint: 'Seçim olmadan alan her belge türüne uygulanır.',
    preview: 'Canlı önizleme',
    previewHint: 'Alan formda bu şekilde görünür.',
    previewLabel: 'Yeni alan',
    moveUp: 'Yukarı git',
    moveDown: 'Aşağı git',
    archive: 'Arşiv',
    archiveTitle: 'Özel alanı arşivle',
    archiveDescription: '“{{label}}” alanı gizlidir; Yakalanan değerler kalır.',
    entities: {
      CUSTOMER: 'İş ortakları',
      CONTACT: 'İrtibat kişileri',
      ADDRESS: 'Adresler ve teslimat adresleri',
      PRODUCT: 'Ürünler',
      PRODUCT_PACKAGING: 'Ürün ambalajları',
      DOCUMENT: 'Belge başlığı',
      DOCUMENT_ITEM: 'Belge öğesi satırı',
      BATCH: 'Gruplar',
    },
    documentTypes: {
      QUOTE: 'Alıntı',
      ORDER: 'Sipariş',
      DELIVERY_NOTE: 'Teslimat notu',
      INVOICE: 'Fatura',
      PURCHASE_ORDER: 'Satınalma siparişi',
    },
    formula: {
      title: 'Formül',
      expression: 'İfade',
      expressionHint:
        '+ - * / parantezlere izin verilir, || geri dönüşler ve abs, minimum, maksimum, yuvarlak, zemin ve tavan için.',
      invalid: 'Formül geçersiz.',
      unit: 'Birim',
      unitHint: 'Sonuçtan sonra gösterilir, ör. €/adet.',
      decimals: 'Ondalık basamaklar',
      testTitle: 'Canlı test',
      result: 'Sonuç',
      variables: {
        title: 'Mevcut değişkenler – eklemek için tıklayın',
        quantity: 'Adet',
        unitPrice: 'Birim fiyatı',
        discountPercent: "İndirim %'si",
        taxRate: 'Vergi oranı',
        lineNet: 'Hat ağı',
        lineGross: 'Satır brüt',
        lineTotal: 'Satır toplamı',
      },
    },
    types: {
      WEEKLY_SCHEDULE: 'Haftanın günleri ve saatler',
      TEXT: 'Metin',
      TEXTAREA: 'Çok satırlı metin',
      NUMBER: 'Tamsayı',
      DECIMAL: 'Ondalık',
      DATE: 'Tarih',
      CHECKBOX: 'Evet/Hayır',
      SELECT: 'Tek seçim',
      MULTI_SELECT: 'Çoktan seçmeli',
      FORMULA: 'Hesaplanan alan',
    },
  },
  auditVault: {
    title: 'GoBD denetim kasası',
    subtitle: 'Eksiksiz, kriptografik olarak zincirlenmiş değişiklik geçmişi.',
    error: 'Günlük yüklenemedi.',
    empty: 'Seçilen filtreler için giriş yok.',
    integrityTitle: 'Dürüstlük ve vergi verilerini dışa aktarma',
    integrityHint:
      'Kontrol, her karmayı yeniden hesaplar ve uyumsuzlukları ve eksik sayıları rapor eder.',
    verify: 'Karma zincirini doğrula',
    exportCsv: 'GoBD dışa aktarma (CSV)',
    exportXml: 'GDPdU dışa aktarımı (XML)',
    exportReady: 'Dışa aktarma oluşturuldu.',
    intact: 'Tüm {{count}} girişleri değiştirilmemiştir.',
    broken: '{{count}} bütünlük ihlalleri bulundu.',
    verifiedAt: "{{timestamp}}'de {{duration}} ms'de doğrulandı.",
    headHash: 'Kafa sağlama toplamı',
    filterEntity: 'Filtre varlığı',
    filterAction: 'Filtre eylemi',
    allEntities: 'Tüm varlıklar',
    allActions: 'Tüm eylemler',
    from: 'Başlangıç',
    to: 'Bitiş',
    timestamp: 'Zaman Damgası',
    action: 'Eylem',
    entity: 'Varlık',
    user: 'Kullanıcı',
    hash: 'Sağlama Toplamı',
    previousHash: 'Selef',
    origin: 'Menşei',
    diffTitle: 'Günlük girişi #{{sequence}}',
    field: 'Alan',
    before: 'Önce',
    after: 'Sonra',
    noPayload: 'Bu eylem hiçbir yük taşımamaktadır.',
    changedFields: '{{total}} alanlarından {{count}} değiştirildi.',
    actions: {
      INSERT: 'Oluşturuldu',
      UPDATE: 'Güncellendi',
      DELETE: 'Silindi',
      LOCK: 'Kilitli',
      EXPORT: 'Dışa Aktarıldı',
      REVERT: 'Geri döndürüldü',
    },
    breaches: {
      HASH_MISMATCH: 'Sağlama toplamı veri yüküyle eşleşmiyor.',
      CHAIN_BROKEN: 'Önceki sürüme olan bağlantı koptu.',
      SEQUENCE_GAP: 'Sıra numaralarında boşluk.',
    },
    entities: {
      Customer: 'Müşteri',
      Product: 'Ürün',
      ProductBatch: 'Toplu',
      Document: 'Belge',
      DocumentItem: 'Belge öğesi',
      StockMovement: 'Stok hareketi',
      DatevExportLog: 'DATEV dışa aktarımı',
      IntrastatExportLog: 'Intrastat dışa aktarımı',
      CompanyProfile: 'Şirket profili',
      CustomFieldDefinition: 'Özel alan',
      VatIdVerification: 'KDV numarası doğrulama kanıtı',
      DunningSettings: 'Hatırlatma ayarları',
      DunningStage: 'Hatırlatma seviyesi',
      CustomerDunningPolicy: 'Müşteri hatırlatma koşulları',
      DunningRun: 'Hatırlatma çalıştırması',
      DunningNotice: 'Ödeme hatırlatması',
      DunningNoticeSnapshot: 'Onaylı hatırlatma anlık görüntüsü',
      DunningNoticeItem: 'Hatırlatılan açık kalem',
      DunningStatusEvent: 'Hatırlatma durum kanıtı',
      DunningDispatch: 'Hatırlatma gönderim kanıtı',
      CustomerPayment: 'Müşteri ödemesi',
      CustomerPaymentAllocation: 'Ödeme tahsisi',
      VatValidationSettings: 'KDV numarası doğrulama ayarları',
      ProductionLotGenealogyEdge: 'Parti soyağacı bağlantısı',
      RecallSimulation: 'Geri çağırma simülasyonu',
      RecallSimulationAnchor: 'Geri çağırma başlangıç partisi',
      RecallSimulationAffectedBatch: 'Geri çağırmadan etkilenen parti',
      RecallSimulationOperation: 'Geri çağırma işlemi',
    },
  },
  dataHub: {
    title: 'İçe ve dışa aktarma',
    subtitle: 'CSV veya Excel dosyalarından ana verileri devralın.',
    step1: 'Dosya seç',
    step1Hint: "CSV veya Excel'i sürükleyip bırakarak veya dosya seçiciyle.",
    step2: 'Harita sütunları',
    step2Hint: 'Eşleşen adlara sahip sütunlar önceden atanmıştır.',
    step3: 'Doğrula ve içe aktar',
    step3Hint: 'Prova işlemi veritabanına hiçbir şey yazmaz.',
    target: 'Hedef alan',
    dropHere: 'Dosyayı buraya bırakın',
    formats: "10 MB'a kadar .csv ve .xlsx dosyalarını destekler.",
    chooseFile: 'Dosya seç',
    uploaded: '{{fileName}} · {{rows}} satırları, {{columns}} sütunları algılandı.',
    sourceColumn: 'Kaynak sütunu',
    sample: 'Örnek değerler',
    targetField: 'ERP alanı',
    ignore: 'İçe aktarma',
    runDryRun: 'Deneme çalışmasını başlat',
    validRows: '{{count}} geçerli satırlar',
    invalidRows: '{{count}} geçersiz satırlar',
    row: 'Satır',
    field: 'Alan',
    reason: 'Sebep',
    startImport: '{{count}} satırlarını içe aktar',
    imported: '{{success}} kayıtları oluşturuldu, {{failed}} atlandı.',
    history: 'İçe aktarma geçmişi',
    historyHint: 'Tamamlanan çalıştırmalar tamamen geri alınabilir.',
    noJobs: 'Henüz içe aktarma işlemi gerçekleştirilmiyor.',
    file: 'Dosya',
    progress: 'İlerleme',
    status: 'Durum',
    executedAt: 'Tamamlandı',
    rowSummary: '{{success}} içe aktarıldı · {{failed}} hataları · {{total}} toplamı',
    rollback: 'Geri al',
    rolledBack: 'İçe aktarma geri alındı.',
    entities: {
      CUSTOMER: 'Müşteriler',
      PRODUCT: 'Ürünler',
      STOCK_ADJUSTMENT: 'Hisse senedi ayarlamaları',
    },
    statuses: {
      PENDING: 'Beklemede',
      PROCESSING: 'Çalışıyor',
      COMPLETED: 'Tamamlandı',
      FAILED: 'Başarısız',
      ROLLED_BACK: 'Geri döndürüldü',
    },
  },
  backupCenter: backupCenterTr,
  backupRestore: backupRestoreTr,
  mailBackups: {
    title: 'Posta gönderimi',
    subtitle: 'Giden postaları ve SMTP yapılandırmasını kontrol edin.',
    smtpTitle: 'SMTP teşhisi',
    smtpHint: 'Posta sunucusundaki bağlantıyı, şifrelemeyi ve kimlik doğrulamayı kontrol eder.',
    testConnection: 'Bağlantıyı test edin',
    sendTest: 'Test mesajı gönder',
    recipient: 'Alıcı',
    testSent: 'Test mesajı gönderildi.',
    testFailed: 'Test mesajı gönderilemedi.',
    reachable: 'Ulaşılabilir',
    unreachable: 'Ulaşılamıyor',
    queueTitle: 'Başarısız belge postaları',
    queueHint: 'Yeniden gönderme doğrudan belge üzerinde yapılabilir.',
    queueEmpty: 'Başarısız teslimat yok.',
    document: 'Belge',
    errorMessage: 'Hata',
    attemptedAt: 'Şunu yapmaya teşebbüs edildi:',
    backupsTitle: 'Yedeklemeler',
    backupsHint: 'Yedekleme dizinindeki şifrelenmiş arşivler (AES-256-GCM).',
    createNow: 'Şimdi yedekleme oluştur',
    backupCreated: 'Yedekleme oluşturuldu.',
    noBackups: 'Henüz yedekleme mevcut değil.',
    archive: 'Arşiv',
    size: 'Boyut',
    createdAt: 'Oluşturulma tarihi:',
    checksum: 'Sağlama Toplamı',
    download: 'İndir',
    delete: 'Sil',
    deleted: 'Yedekleme silindi.',
    deleteTitle: 'Yedekleme silinsin mi?',
    deleteDescription:
      '"{{fileName}}" arşivi sunucudan kalıcı olarak kaldırılacak. Zaten indirilmiş olan kopyalar etkilenmez.',
    writable: 'Yazılabilir dizin',
    notWritable: 'Dizin yazılamaz',
    dumpAvailable: 'pg_dump mevcut',
    dumpMissing: 'pg_dump eksik — yedeklemeler ana bilgisayar cronu aracılığıyla çalıştırılır',
    cron: 'Program (cron)',
    retention: 'Saklama (gün)',
    storageTarget: 'Depolama hedefi',
    encrypted: 'Şifrele',
    scheduleActive: 'Program aktif',
    lastRun: 'Son çalıştırma: {{timestamp}} · {{status}}',
    targets: {
      LOCAL: 'Yerel hacim',
      S3: 'S3 uyumlu',
      OFFSITE_SSH: 'Tesis dışı SSH depolama',
    },
  },
} as const;
